// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISmartPackageGiftDtoV4 {
  /** тип **/
  type: EType;
  /** типы услуги **/
  serviceType?: EServiceType;
  /** Количество размещений на данную услугу **/
  count: number;
  /** Длительность **/
  durationInDays: number;
  /** Количество размещений на данную услугу **/
  auctionPoints: number;
  /** Длительность **/
  cashbackPercent: number;
}
export enum EType {
  /** Cashback **/
  'Cashback' = 'cashback',
  /** vas **/
  'Vas' = 'vas',
}
export enum EServiceType {
  /** Платное **/
  'DebitObject' = 'debitObject',
  /** Премиум публикация - 103 **/
  'PremiumObject' = 'premiumObject',
  /** Тор 3 - 104 **/
  'Top3' = 'top3',
  /** Аукцион **/
  'Auction' = 'auction',
  /** Аукцион **/
  'Standard' = 'standard',
}
